import { Icon } from '../common';
import type { ListState } from './filterTypes';

export interface BookingsEmptyProps {
  variant: 'no-bookings' | 'no-matches';
  // The Type in force (viewings-in-the-bookings-list): the copy names what
  // would live here, and an empty Viewing list offers the way back to bookings.
  kind?: ListState;
  onClearFilters?: () => void;
  onShowBookings?: () => void;
}

const NOUN: Record<ListState, string> = { all: 'bookings', booking: 'bookings', viewing: 'viewings' };

// AC4 empty state — two variants. Designed moment, not a bare string.
// Built strictly from existing tokens (Maya error-and-loading.md).
export function BookingsEmpty({ variant, kind = 'all', onClearFilters, onShowBookings }: BookingsEmptyProps) {
  const noun = NOUN[kind];
  if (variant === 'no-matches') {
    return (
      <div className="bookings-empty">
        <span className="bookings-empty-icon bg-tint">
          <Icon name="search" size={22} />
        </span>
        <div className="bookings-empty-headline">No {noun} match</div>
        <p className="bookings-empty-msg">No {noun} match the current filters.</p>
        {onClearFilters && (
          <button type="button" className="bookings-empty-action" onClick={onClearFilters}>
            Clear filters
          </button>
        )}
      </div>
    );
  }
  if (kind === 'viewing') {
    return (
      <div className="bookings-empty">
        <span className="bookings-empty-icon brand-soft">
          <Icon name="eye" size={22} />
        </span>
        <div className="bookings-empty-headline">No viewings yet</div>
        <p className="bookings-empty-msg">
          Nobody has been logged as coming to look round. Log one from Daily and it will appear here.
        </p>
        {onShowBookings && (
          <button type="button" className="bookings-empty-action" onClick={onShowBookings}>
            Show bookings instead
          </button>
        )}
      </div>
    );
  }
  return (
    <div className="bookings-empty">
      <span className="bookings-empty-icon brand-soft">
        <Icon name="calendar" size={22} />
      </span>
      <div className="bookings-empty-headline">No bookings yet</div>
      <p className="bookings-empty-msg">
        Your bookings will appear here once they&rsquo;re imported from the legacy system. This is a
        read-only view — bookings are created elsewhere.
      </p>
    </div>
  );
}
